import React, { useEffect, useState } from 'react';
import { MobileMenu } from './MobileMenu';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const heroThreshold = window.innerHeight * 0.8;
      // Toggle scrolled state at 80% of hero height
      setIsScrolled(currentScrollY > heroThreshold);
      // Hide/show on scroll direction (only when in scrolled mode)
      if (currentScrollY > heroThreshold) {
        if (currentScrollY > lastScrollY && currentScrollY > heroThreshold + 80) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
      } else {
        setIsVisible(true);
      }
      setLastScrollY(currentScrollY);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);
  return <>
      <header className={`fixed top-0 left-0 right-0 z-30 flex items-center justify-between px-6 md:px-12 transition-all duration-300 ease-in-out ${isScrolled ? `h-[60px] bg-white border-b border-gray-100 ${isVisible ? 'translate-y-0' : '-translate-y-full'}` : 'pt-6 md:pt-8 h-[100px] md:h-[120px] bg-transparent border-b border-transparent items-start'}`} data-id="element-95">
        {/* Left - Hamburger */}
        <button onClick={() => setIsMenuOpen(true)} className="group p-2 -ml-2" aria-label="Open menu" data-id="element-96">
          <div className="flex flex-col space-y-1.5 items-start" data-id="element-97">
            <span className={`block w-8 h-[2px] transition-colors duration-300 ${isScrolled ? 'bg-charcoal group-hover:bg-gold' : 'bg-white group-hover:bg-white/70'}`} data-id="element-98"></span>
            <span className={`block w-8 h-[2px] transition-colors duration-300 ${isScrolled ? 'bg-charcoal group-hover:bg-gold' : 'bg-white group-hover:bg-white/70'}`} data-id="element-99"></span>
            <span className={`block w-8 h-[2px] transition-colors duration-300 ${isScrolled ? 'bg-charcoal group-hover:bg-gold' : 'bg-white group-hover:bg-white/70'}`} data-id="element-100"></span>
          </div>
        </button>

        {/* Center - Logo */}
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-101">
          <a href="#" className="hover:opacity-80 transition-opacity duration-300" data-id="element-102">
            <img src="https://assets.modern-commerce.io/Glenlofty%20Project%20Files/Logo-GLE.png" alt="Glenlofty" className={`w-auto transition-all duration-300 ${isScrolled ? 'h-10 md:h-12' : 'h-16 md:h-20 brightness-0 invert'}`} data-id="element-103" />
          </a>
        </div>

        {/* Right - Spacer to balance layout */}
        <div className="w-8 md:w-12" data-id="element-104"></div>
      </header>

      <MobileMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} data-id="element-105" />
    </>;
}